import React, { useCallback, useState } from "react";
import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import useAppSelector from "~/hooks/use-app-selector.ts";
import ReactInvalidComponentStateError from "~/utils/react-invalid-component-state-error.ts";
import { deleteSavedProject, cancelDeleteSavedProject } from "./store-slice.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

function ConfirmDeleteModal() {
	const dispatch = useAppDispatch();
	const t = useTranslator();
	const pendingDeleteDesignId = useAppSelector(
		(s) => s.user.deleteSavedProjectStatus?.id,
	);
	const [deleting, setDeleting] = useState(false);
	const onConfirm = useCallback(async () => {
		if (!pendingDeleteDesignId) {
			throw new ReactInvalidComponentStateError(
				"Expected pendingDeleteDesignId to be set",
			);
		}
		setDeleting(true);
		try {
			await dispatch(deleteSavedProject(pendingDeleteDesignId));
		} finally {
			setDeleting(false);
		}
	}, [pendingDeleteDesignId, dispatch]);
	const onCancel = useCallback(() => {
		dispatch(cancelDeleteSavedProject());
	}, [dispatch]);

	return (
		<Modal
			show={!!pendingDeleteDesignId}
			title={t("WARNING!")}
			disabled={deleting}
		>
			<Modal.Text>
				{t("Are you sure you want to Delete this project?")}
			</Modal.Text>
			<Modal.Actions
				disabled={deleting}
				actions={[
					{ text: t("Yes"), onClick: onConfirm },
					{ text: t("Cancel"), onClick: onCancel, type: "ghost" },
				]}
			/>
		</Modal>
	);
}

export default ConfirmDeleteModal;
